import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import SignUpFormComponent from "../../components/signUpForm/signUpForm";

export default function SignUpPage() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Sign Up | Prepal</title>
        <meta name="description" content="Sign up your Prepal account to access personalized test preparation tools." />
        <meta name="keywords" content="Prepal, sign up, test prep, education" />
        <meta name="author" content="Prepal Team" />
      </Helmet>
      <SignUpFormComponent />
    </>
  );
}